import React from 'react';
import { Modal } from "@kursk/components/ui/Modal/Modal";
import { Button } from "@kursk/components/ui/Button/Button";
import styles from "@kursk/components/ui/FeedbacksBlock/FeedBacksBlock.module.scss";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SuccessFeedback = ({ isOpen, setIsOpen }: Props) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={() => setIsOpen(false)} classNameWrapper={styles.successWrapper}>
      <div className={styles.successTitle}>
        Спасибо за отзыв!
      </div>
      <div className={styles.successDescription}>
        Отзыв будет опубликован после проверки администратором.
      </div>
      <Button text='Закрыть' onClick={() => setIsOpen(false)} buttonType='greenPrimary'/>
    </Modal>
  );
};

